const API_BASE_URL = process.env.REACT_APP_API_URL || "";

function parseProfilePhotoMaxMb(raw) {
  const n = Number.parseInt(String(raw ?? "").trim(), 10);
  if (!Number.isFinite(n) || n < 1) return 10;
  return Math.max(10, Math.min(50, n));
}

/** Keep in sync with jobuwin-api `PROFILE_PHOTO_MAX_MB` (default 10). */
export const PROFILE_PHOTO_MAX_MB = parseProfilePhotoMaxMb(process.env.REACT_APP_PROFILE_PHOTO_MAX_MB);
export const PROFILE_PHOTO_MAX_BYTES = PROFILE_PHOTO_MAX_MB * 1024 * 1024;

export const appConfig = {
  API_BASE_URL,
};

/** Local CRA dev: same-origin /api/* → jobuwin-api (craco.config.js devServer.proxy). */
function useLocalDevProxy() {
  if (process.env.NODE_ENV !== "development") return false;
  const base = API_BASE_URL.trim();
  // Empty REACT_APP_API_URL: use relative `/api/v1/...` so the dev server proxy can reach jobuwin-api.
  if (!base) return true;
  try {
    const { hostname } = new URL(base);
    return (
      hostname === "localhost" ||
      hostname === "127.0.0.1" ||
      hostname === "[::1]" ||
      hostname === "::1"
    );
  } catch {
    return false;
  }
}

export function buildApiUrl(path = "") {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  if (useLocalDevProxy()) {
    return `/api/v1${normalizedPath}`;
  }
  return `${appConfig.API_BASE_URL}${normalizedPath}`;
}

/** e.g. http://localhost:4000 — for paths not under /api/v1 (such as /api/test). */
export function getApiOrigin() {
  const base = appConfig.API_BASE_URL.trim();
  if (!base) return "";
  try {
    return new URL(base).origin;
  } catch {
    return base.replace(/\/api\/v1\/?$/i, "");
  }
}
